
module.exports = {"attributes":{"width":"28","height":"40"},"content":"<path d=\"M9 1.4c4.9 0 7.7 2.4 7.7 8.3 0 5.7-2.6 9-7.8 9H6.1v1.1H9c5.3 0 8.3 3 8.3 8.3 0 5.5-2.9 9.3-9.8 9.3-2.9 0-5.1-.3-7.4-1.5v1C2.7 38.7 7 40 12.5 40 22.2 40 28 35.8 28 28.9c0-6.5-5.1-9.6-15-9.7V19c9.5-.7 13.6-4.4 13.6-9.3 0-6.4-4.4-9.7-13.8-9.7-4 0-8.5.8-11.4 1.7v8.5h1.1l2.4-8.4A21 21 0 0 1 9 1.4z\"/>"}
var desvg = require('@kossnocorp/desvg/react')
module.exports = desvg(module.exports)
